import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { Loader } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class Login extends React.Component {
	@observable login = '';
	@observable password = '';
	@observable error = null;
	@observable isLoading = false;

	onLoginChange = e => (this.login = e.target.value);
	onPasswordChange = e => (this.password = e.target.value);

	doLogin = async e => {
		e.preventDefault();
		this.isLoading = true;
		this.error = null;
		try {
			await store.model.login(this.login, this.password);
		} catch (e) {
			console.warn(e);
			if (e.statusCode === 401) {
				this.error = 'Введена неверная пара логин/пароль';
			} else {
				this.error = e.message;
			}
		} finally {
			this.isLoading = false;
		}
	};

	render() {
		return (
			<form onSubmit={this.doLogin}>
				<div className={'login-page' + (this.isLoading ? ' is-loading' : '')}>
					<div className="form-field">
						<label>E-mail</label>
						<input type="text" value={this.login} onChange={this.onLoginChange} />
					</div>
					<div className="form-field">
						<label>Пароль</label>
						<input type="password" value={this.password} onChange={this.onPasswordChange} />
					</div>
					{this.error && (
						<div className="form-error" style={{ color: 'red', marginTop: '10px' }}>
							{this.error}
						</div>
					)}
					<div className="form-buttons">
						{this.isLoading && (
							<>
								<Loader size={30} /> &nbsp;
							</>
						)}
						<button className="white-btn" type="submit" disabled={this.isLoading}>
							Войти
						</button>
					</div>
				</div>
			</form>
		);
	}
}
